import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { sizes } from '../utils/breakpoints'

const CardComponent = ({ index, title, subtitle, tag, to, onClick, compact }) => {
  return (
    <Container as={to ? Link : 'div'} to={to} onClick={onClick} $compact={compact}>
      {tag && <Tag>{tag}</Tag>}
      {index != null && <Number>{String(index).padStart(2, '0')}</Number>}
      <SectionText>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </SectionText>
    </Container>
  )
}

export default CardComponent

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: ${({ $compact }) => ($compact ? '24px 28px' : '36px 32px')};
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  background: ${({ theme }) => theme.colors.background.card};
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${({ theme }) => theme.shadows.cardHover};
  }

  @media (max-width: ${sizes.mobile}px) {
    padding: ${({ $compact }) => ($compact ? '16px 20px' : '20px')};
    border-radius: 12px;
  }
`

const Number = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 15px;
  letter-spacing: 0.08em;
  color: ${({ theme }) => theme.colors.brand.green};
  background-color: ${({ theme }) => theme.colors.brand.dark};
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 8px;
  margin-bottom: 20px;

  @media (max-width: ${sizes.mobile}px) {
    width: 26px;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    margin-bottom: 12px;
  }
`

const Tag = styled.span`
  position: absolute;
  top: -11px;
  left: 32px;
  font-family: ${({ theme }) => theme.fonts.accentBold};
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.brand.dark};
  background-color: ${({ theme }) => theme.colors.brand.green};
  padding: 4px 10px;
  border-radius: 999px;
  box-shadow: ${({ theme }) => theme.shadows.card};

  @media (max-width: ${sizes.mobile}px) {
    top: -9px;
    left: 20px;
    font-size: 9px;
    padding: 3px 8px;
  }
`

const SectionText = styled.div`
  text-align: left;
`

const Title = styled.p`
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 28.8px;
  font-size: 22px;
  font-family: ${({ theme }) => theme.fonts.heading};
  margin: 0 0 12px;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 16px;
    line-height: 19.2px;
    margin: 0 0 8px;
  }
`

const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 22px;
  font-size: 15px;
  font-family: ${({ theme }) => theme.fonts.accentRegular};
  margin: 0;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
    line-height: 16px;
  }
`
